import Marquee from "react-fast-marquee";
import { Diamond } from "lucide-react";
import { MARQUEE_ITEMS } from "@/lib/data";

const Ribbon = () => (
  <div data-testid="services-marquee" className="border-y border-slate-900/10 bg-white py-5 overflow-hidden">
    <Marquee speed={35} gradient={false} pauseOnHover>
      {MARQUEE_ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span className="font-display text-xl sm:text-2xl font-bold uppercase tracking-wide text-slate-700 px-6">
            {item}
          </span>
          <Diamond className="w-3 h-3 text-sky-600 fill-sky-400" />
        </span>
      ))}
    </Marquee>
  </div>
);

export default Ribbon;
